import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com"; // Import EmailJS

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { slideIn } from "../utils/motion";

// Function to sanitize inputs
const sanitizeInput = (input) => {
  return input.replace(/[<>&"']/g, (match) => ({
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#x27;',
  })[match]);
};

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Sanitize form data before sending
    const sanitizedName = sanitizeInput(form.name);
    const sanitizedEmail = sanitizeInput(form.email);
    const sanitizedMessage = sanitizeInput(form.message);

    emailjs
      .send(
        import.meta.env.VITE_EMAILJS_SERVICE_ID, // Your EmailJS Service ID
        import.meta.env.VITE_EMAILJS_TEMPLATE_ID, // Your EmailJS Template ID
        {
          from_name: sanitizedName,
          from_email: sanitizedEmail,
          message: sanitizedMessage,
          reply_to: sanitizedEmail, // Ensure this is correctly set
        },
        import.meta.env.VITE_EMAILJS_PUBLIC_KEY // Your EmailJS Public Key
      )
      .then(
        (response) => {
          setLoading(false);
          setMessageSent(true);
          setForm({
            name: "",
            email: "",
            message: "",
          });
          alert("Thank you. I will get back to you as soon as possible.");
        },
        (error) => {
          setLoading(false);
          console.error("EmailJS Error:", error);
          alert("Ahh, something went wrong. Please try again.");
        }
      );
  };

  return (
    <div className="xl:mt-12 flex xl:flex-row flex-col-reverse gap-10 overflow-hidden">
      {/* Contact Form with Hover Effect */}
      <motion.div
        variants={slideIn("left", "tween", 0.2, 1)}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="flex-[0.75] bg-black-100 p-8 rounded-2xl"
      >
        <p className={styles.sectionSubText}>Neem contact op</p>
        <h3 className={styles.sectionHeadText}>Contact.</h3>

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="mt-12 flex flex-col gap-8"
        >
          <label className="flex flex-col">
            <span className="text-white font-medium mb-4">Uw naam</span>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="What's your good name?"
              className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium"
            />
          </label>
          <label className="flex flex-col">
            <span className="text-white font-medium mb-4">Jouw email</span>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="What's your web address?"
              className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium"
            />
          </label>
          <label className="flex flex-col">
            <span className="text-white font-medium mb-4">Jouw Bericht</span>
            <textarea
              rows={7}
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="What you want to say?"
              className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium"
            />
          </label>

          <button
            type="submit"
            className="bg-tertiary py-3 px-8 rounded-xl outline-none w-fit text-white font-bold shadow-md shadow-primary"
            disabled={loading}
          >
            {loading ? "Bezig met verzenden..." : "Versturen"}
          </button>
        </form>

        {messageSent && (
          <p className="mt-4 text-green-500 font-medium">
            Dank u wel. Ik zal zo spoedig mogelijk contact met u opnemen.
          </p>
        )}
      </motion.div>

      {/* Map with Hover Effect and Curved Edges */}
      <motion.div
        variants={slideIn("right", "tween", 0.2, 1)}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="xl:flex-1 xl:h-auto md:h-[550px] h-[350px] rounded-2xl overflow-hidden"  // Rounded map container
      >
        <iframe
  title="FairPlaza Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.307784274953!2d5.22617!3d51.9418094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c65fd1ef69adb9%3A0x2878462ae42f0b6e!2sFairPlaza!5e0!3m2!1sen!2snl!4v1714988030407!5m2!1sen!2snl"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>


      </motion.div>
    </div>
  );
};

export default SectionWrapper(Contact, "contact");
